import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import ResourceCard from 'common/components/ResourceCard';
import { replace } from 'react-router-redux';
import { createNode, updateNode } from 'catalog/actions/node';
import { success } from 'plugins/toastr';
import NodeForm from 'catalog/components/NodeForm';

const addButtonLabel = props =>
  props.params.parent ? 'Créer' : 'Mettre à jour';

const isColorDisabledForCatalog = catalog => catalog !== 'products';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.params;
  return {
    current: id ? state.catalog.nodes.get(id) : null,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  saveNode: node => {
    const { id, parent } = ownProps.params;
    if (parent) {
      return dispatch(createNode(ownProps.catalog, parent, node));
    } else if (id) {
      return dispatch(updateNode(ownProps.catalog, { ...node, id }));
    }
  },
});
class NodeEditionPage extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    current: PropTypes.object,
    params: React.PropTypes.object.isRequired,
    catalog: PropTypes.string.isRequired,
    saveNode: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props);

    this.state = {
      tabletFieldsDisabled: false,
    };

    this._setImage = this._setImage.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this._setTabletImage = this._setTabletImage.bind(this);
    this.renderTabletImage = this.renderTabletImage.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { current } = this.props;

    this.setState({
      tabletFieldsDisabled: !(
        current &&
        current.tablet_image &&
        current.tablet_image.image
      ),
    });
  }

  onSubmit(values, dispatch) {
    const { node: parent, saveNode } = this.props;

    const nullIfEmpty = v => (v.length > 0 ? v : null);
    const nullIfNotSet = (field, thunk) => {
      if (field) {
        return thunk(field);
      }

      return null;
    };

    const tabletImage = {
      gravity: nullIfEmpty(values.gravity),
      scale_type: nullIfEmpty(values.scaleType),
      color: nullIfEmpty(values.tabletColor),
      id: nullIfNotSet(this.tabletImage, i => i.getValue()),
      image: nullIfNotSet(this.tabletImage, i => i.getResource()),
    };

    // Add selected image to form values
    const toSave = Object.assign({}, values, {
      template: nullIfEmpty(values.template),
      image: this.image.getResource(),
      image_id: this.image.getValue(),
      tablet_image: tabletImage,
    });

    return new Promise((resolve, reject) => {
      saveNode(toSave)
        .then(() => {
          let url, message;
          if (parent.parent) {
            url = `/nodes/${parent.parent}`;
            message = 'Noeud mis à jour avec succès';
          } else {
            url = `/nodes/${parent.id}`;
            message = 'Noeud créé avec succès';
          }

          dispatch(replace(url));
          success(message);
          resolve();
        })
        .catch(err => reject(err));
    });
  }

  _setImage(ref) {
    this.image = ref;
  }

  renderImage() {
    const { current } = this.props;
    const image = current ? current.image : null;

    return (
      <ResourceCard
        ref={this._setImage}
        name="image"
        title="Image"
        resource={image}
      />
    );
  }

  _setTabletImage(ref) {
    this.tabletImage = ref;
  }

  renderTabletImage() {
    const { current } = this.props;
    const image =
      current && current.tablet_image ? current.tablet_image.image : null;

    const enableTabletFields = () =>
      this.setState({ tabletFieldsDisabled: false });
    const disableTabletFields = () =>
      this.setState({ tabletFieldsDisabled: true });

    return (
      <ResourceCard
        ref={this._setTabletImage}
        name="tablet_image"
        title="Visuel tablette"
        resource={image}
        onChange={enableTabletFields}
        onDelete={disableTabletFields}
      />
    );
  }

  render() {
    const { catalog, current } = this.props;
    const { tabletFieldsDisabled } = this.state;

    return (
      <NodeForm
        node={current}
        label={addButtonLabel(this.props)}
        onSubmit={this.onSubmit}
        colorDisabled={isColorDisabledForCatalog(catalog)}
        tabletFieldsDisabled={tabletFieldsDisabled}
        renderImage={this.renderImage}
        renderTabletImage={this.renderTabletImage}
      />
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  NodeEditionPage
);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodeEditionPage.js